module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#arcade",
      toString: function () {
        return this.url;
      }
    }